/* eslint-disable radix */
import Layout from "../../components/Layout/Layout";
import Button from "../../components/Button/Button";
import PageTitle from "../../components/PageTitle/PageTitle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Grid, Switch, Checkbox, FormControlLabel } from "@mui/material";
import PricingComponent from "../../components/Pricing/PricingComponent";
import styles from "./PriceEdit.module.css";
import Modal from "../../components/Modal";
import InputGroup from "../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../components/FormComponent/TextAreaGroup";
import { useEffect, useState } from "react";
import Select from "react-select";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast, ToastContainer } from "react-toastify";
import { httprequest } from "../../data/api";
import useStyles from "./styles";

const PRICING_ENDPOINT = "/admin/v1/pricing-plan/";
const AVAILABLE_FEATURES = "/admin/v1/pricing-plan/available-features";
const VARIANT = "/admin/v1/pricing-plan/variants/";

const emptyBillingFrequency = () => ({ monthly: "", quarterly: "", yearly: "" });

const normalizeBillingFrequency = (billingFrequency, legacyPrice = "") => ({
  monthly: billingFrequency?.monthly ?? legacyPrice ?? "",
  quarterly: billingFrequency?.quarterly ?? "",
  yearly: billingFrequency?.yearly ?? ""
});

const parseBillingFrequency = (billingFrequency = {}) => {
  const result = {};

  ["monthly", "quarterly", "yearly"].forEach((key) => {
    const value = billingFrequency?.[key];
    if (value !== "" && value != null && !Number.isNaN(Number(value)) && Number(value) > 0) {
      result[key] = Number(value);
    }
  });

  return result;
};

const hasValidBillingFrequency = (billingFrequency) => Object.keys(parseBillingFrequency(billingFrequency)).length > 0;

const formatPlanAmount = (model) => {
  const currency = model.currency || "₦";
  const monthly = model.billing_frequency?.monthly ?? model.price ?? 0;

  return `${currency}${Number(monthly || 0).toLocaleString()}/mo`;
};

const Pricing = () => {
  const classes = useStyles();
  const [addpricemodal, setAddPriceModal] = useState();
  const [editpricemodal, setEditPriceModal] = useState(false);
  const [pricingModels, setPricingModels] = useState([]);
  const [currentModelId, setCurrentModelId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    billing_frequency: emptyBillingFrequency(),
    currency: "",
    features: [""],
    description: "",
    max_users: "",
    // max_enrolment_applications: "",
    plan_level: 1,
    allowed_features: [],
    has_variant: false,
    variants: [
      {
        name: "",
        max_users: "",
        billing_frequency: emptyBillingFrequency()
      }
    ]
  });
  const [editFormData, setEditFormData] = useState({
    name: "",
    billing_frequency: emptyBillingFrequency(),
    currency: "",
    features: [""],
    description: "",
    max_users: "",
    // max_enrolment_applications: "",
    plan_level: 1,
    allowed_features: [],
    has_variant: false,
    variants: [
      {
        name: "",
        max_users: "",
        billing_frequency: emptyBillingFrequency()
      }
    ]
  });

  // State for variant editing
  const [editingVariantIndex, setEditingVariantIndex] = useState(null);
  const [variantEditData, setVariantEditData] = useState({
    name: "",
    max_users: "",
    billing_frequency: emptyBillingFrequency()
  });

  // State for variant deletion
  const [deleteVariantModal, setDeleteVariantModal] = useState(false);
  const [variantToDelete, setVariantToDelete] = useState(null);
  const [deleteVariantLoading, setDeleteVariantLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [availableFeature, setAvailableFeature] = useState([]);
  const [variantLoading, setVariantLoading] = useState(false);

  const currencyOptions = [
    { value: "₦", label: "Nigerian Naira" },
    { value: "$", label: "US Dollar" },
    { value: "€", label: "Euro" },
    { value: "£", label: "British Pound" },
    { value: "¥", label: "Japanese Yen" },
    { value: "C$", label: "Canadian Dollar" }
  ];

  const fetchPricingModels = () => {
    httprequest.get(`${PRICING_ENDPOINT}?include_variants=true`)
      .then(res => {
        setPricingModels(res.data.data);
      })
      .catch(err => {
        toast.error(err.response?.data?.message || "Error fetching pricing models");
      });
  };

  const fetchAvailableFeatures = () => {
    httprequest.get(AVAILABLE_FEATURES)
      .then(res => {
        setAvailableFeature(res.data.data);
      })
      .catch(err => {
        toast.error(err.response?.data?.message || "Error fetching pricing models");
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleBillingFrequencyChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      billing_frequency: {
        ...formData.billing_frequency,
        [name]: value
      }
    });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({
      ...editFormData,
      [name]: value
    });
  };

  const handleEditBillingFrequencyChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({
      ...editFormData,
      billing_frequency: {
        ...editFormData.billing_frequency,
        [name]: value
      }
    });
  };

  const handleFeatureChange = (index, value) => {
    const newFeatures = [...formData.features];
    newFeatures[index] = value;
    setFormData({
      ...formData,
      features: newFeatures
    });
  };
  const handleEditFeatureChange = (index, value) => {
    const newFeatures = [...editFormData.features];
    newFeatures[index] = value;
    setEditFormData({
      ...editFormData,
      features: newFeatures
    });
  };

  const handleAddFeature = () => {
    setFormData({
      ...formData,
      features: [...formData.features, ""]
    });
  };
  const handleEditAddFeature = () => {
    setEditFormData({
      ...editFormData,
      features: [...editFormData.features, ""]
    });
  };

  const handleRemoveFeature = (index) => {
    const newFeatures = formData.features.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      features: newFeatures
    });
  };

  const handleEditRemoveFeature = (index) => {
    const newFeatures = editFormData.features.filter((_, i) => i !== index);
    setEditFormData({
      ...editFormData,
      features: newFeatures
    });
  };

  const handleVariantToggle = (e) => {
    const isChecked = e.target.checked;
    const updatedForm = { ...formData };

    if (isChecked) {
      updatedForm.has_variant = true;
      updatedForm.variants = [
        {
          name: "",
          max_users: "",
          billing_frequency: emptyBillingFrequency()
        }
      ];
    } else {
      updatedForm.has_variant = false;
      delete updatedForm.variants;
    }

    setFormData(updatedForm);
  };

  // Handle EDit Toggle
  const handleEditVariantToggle = (e) => {
    const isChecked = e.target.checked;
    const updatedForm = { ...editFormData };

    if (isChecked) {
      updatedForm.has_variant = true;
      updatedForm.variants = [
        {
          name: "",
          max_users: "",
          billing_frequency: emptyBillingFrequency()
        }
      ];
    } else {
      updatedForm.has_variant = false;
      delete updatedForm.variants;
    }

    setEditFormData(updatedForm);
  };

  const handleVariantChange = (index, field, value) => {
    const newVariants = [...formData.variants];
    newVariants[index] = {
      ...newVariants[index],
      [field]: value
    };
    setFormData({
      ...formData,
      variants: newVariants
    });
  };

  const handleVariantBillingChange = (index, frequency, value) => {
    const newVariants = [...formData.variants];
    newVariants[index] = {
      ...newVariants[index],
      billing_frequency: {
        ...emptyBillingFrequency(),
        ...newVariants[index].billing_frequency,
        [frequency]: value
      }
    };
    setFormData({
      ...formData,
      variants: newVariants
    });
  };

  // Handle new variant input changes in edit form
  const handleNewVariantChange = (index, field, value) => {
    const newVariants = [...editFormData.variants];
    newVariants[index] = {
      ...newVariants[index],
      [field]: value
    };
    setEditFormData({
      ...editFormData,
      variants: newVariants
    });
  };

  const handleNewVariantBillingChange = (index, frequency, value) => {
    const newVariants = [...editFormData.variants];
    newVariants[index] = {
      ...newVariants[index],
      billing_frequency: {
        ...emptyBillingFrequency(),
        ...newVariants[index].billing_frequency,
        [frequency]: value
      }
    };
    setEditFormData({
      ...editFormData,
      variants: newVariants
    });
  };

  const handleAddVariant = () => {
    setFormData({
      ...formData,
      variants: [...formData.variants, {
        name: "",
        max_users: "",
        billing_frequency: emptyBillingFrequency()
      }]
    });
  };

  const handleEditAddVariant = () => {
    setEditFormData({
      ...editFormData,
      variants: [...editFormData.variants, {
        name: "",
        max_users: "",
        billing_frequency: emptyBillingFrequency()
      }]
    });
  };

  const handleRemoveVariant = (index) => {
    const newVariants = formData.variants.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      variants: newVariants
    });
  };

  const handleEditRemoveVariant = (index) => {
    const newVariants = editFormData.variants.filter((_, i) => i !== index);
    setEditFormData({
      ...editFormData,
      variants: newVariants
    });
  };

  const handleCurrencyChange = (selectedOption) => {
    setFormData({
      ...formData,
      currency: selectedOption.value
    });
  };

  const handleEditCurrencyChange = (selectedOption) => {
    setEditFormData({
      ...editFormData,
      currency: selectedOption.value
    });
  };

  const handleDescriptionChange = (e) => {
    setFormData({
      ...formData,
      description: e.target.value
    });
  };
  const handleEditDescriptionChange = (e) => {
    setEditFormData({
      ...editFormData,
      description: e.target.value
    });
  };

  const selectedCurrency = currencyOptions.find(option => option?.value === formData?.currency) || null;
  const editselectedCurrency = currencyOptions.find(option => option?.value === editFormData?.currency) || null;

  const resetFormFields = () => {
    setFormData({
      name: "",
      billing_frequency: emptyBillingFrequency(),
      currency: "",
      description: "",
      features: [""],
      allowed_features: [],
      max_users: "",
      max_enrolment_applications: "",
      plan_level: 1,
      has_variant: false,
      variants: [{ name: "", max_users: "", billing_frequency: emptyBillingFrequency() }]
    });
  };

  const editResetFormFields = () => {
    setEditFormData({
      name: "",
      billing_frequency: emptyBillingFrequency(),
      currency: "",
      description: "",
      features: [""],
      allowed_features: [],
      max_users: "",
      max_enrolment_applications: "",
      plan_level: 1,
      has_variant: false,
      variants: [{ name: "", max_users: "", billing_frequency: emptyBillingFrequency() }]
    });
  };

  const handleAddPriceModal = () => {
    setAddPriceModal(!addpricemodal);
    resetFormFields();
  };

  const handleCreatePricingModel = () => {
    setIsLoading(true);

    const billingFrequency = parseBillingFrequency(formData.billing_frequency);
    if (!hasValidBillingFrequency(formData.billing_frequency)) {
      toast.error("Add at least one billing frequency amount greater than 0");
      setIsLoading(false);

      return;
    }

    const newPricingModel = {
      name: formData.name,
      billing_frequency: billingFrequency,
      currency: formData.currency,
      description: formData.description,
      features: formData.features.filter(f => f.trim() !== ""),
      max_users: parseInt(formData.max_users, 10) || null,
      max_enrolment_applications: parseInt(formData.max_enrolment_applications, 10) || null,
      plan_level: formData.plan_level,
      allowed_features: formData.allowed_features,
      has_variant: formData.has_variant,
      variants: formData.has_variant ? formData.variants.filter((v) => v.name.trim() !== "" && v.max_users && hasValidBillingFrequency(v.billing_frequency)).map((v) => ({
        name: v.name.trim(),
        max_users: parseInt(v.max_users, 10),
        billing_frequency: parseBillingFrequency(v.billing_frequency)
      })) : []
    };

    httprequest
      .post(PRICING_ENDPOINT, newPricingModel)
      .then((res) => {
        toast.success(res.data.message);
        setAddPriceModal(false);
        resetFormFields();
        fetchPricingModels();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error creating pricing model");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleEditPriceModal = (model = null) => {
    if (model) {
      setCurrentModelId(model.id);

      setEditFormData({
        name: model.name,
        billing_frequency: normalizeBillingFrequency(model.billing_frequency, model.price),
        currency: model.currency,
        features: model.features || [""],
        description: model.description,
        max_users: model.max_users || "",
        // max_enrolment_applications: model.max_enrolment_applications || "",
        // plan_level: model.plan_level || 1,
        allowed_features: model.allowed_features || [],
        has_variant: model.has_variant || false,
        ...(model.has_variant
          ? {
            variants: (model.variants || []).map((variant) => ({
              ...variant,
              billing_frequency: normalizeBillingFrequency(variant.billing_frequency, variant.price)
            }))
          }
          : {})
      });
    } else {
      editResetFormFields();
    }
    setEditPriceModal(!editpricemodal);
  };

  const handleCloseEditModal = () => {
    setEditPriceModal(!editpricemodal);
    editResetFormFields();
  };

  const handleUpdatePricingModel = () => {
    setIsLoading(true);

    const billingFrequency = parseBillingFrequency(editFormData.billing_frequency);
    if (!hasValidBillingFrequency(editFormData.billing_frequency)) {
      toast.error("Add at least one billing frequency amount greater than 0");
      setIsLoading(false);

      return;
    }

    const payload = {
      name: editFormData.name,
      billing_frequency: billingFrequency,
      description: editFormData.description,
      features: editFormData.features.filter(f => f.trim() !== ""),
      max_users: parseInt(editFormData.max_users, 10) || null,
      allowed_features: editFormData.allowed_features,
      has_variant: editFormData.has_variant
    };

    httprequest
      .patch(`${PRICING_ENDPOINT}${currentModelId}`, payload)
      .then((res) => {
        toast.success(res.data.message);
        setEditPriceModal(false);
        editResetFormFields();
        fetchPricingModels();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error updating pricing model");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteModal = (model) => {
    setCurrentModelId(model.model_id);
    setDeleteModal(!deleteModal);
  };

  const handleDeletePricingModel = () => {
    setDeleteLoading(true);

    httprequest
      .delete(`${PRICING_ENDPOINT}/${currentModelId}`)
      .then((res) => {
        toast.success(res.data.message);
        setDeleteModal(false);
        fetchPricingModels();
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error deleting pricing model");
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  // Variant Edit Functions
  const handleEditVariant = (index, variant) => {
    setEditingVariantIndex(index);
    setVariantEditData({
      name: variant.name || "",
      max_users: variant.max_users || "",
      billing_frequency: normalizeBillingFrequency(variant.billing_frequency, variant.price)
    });
  };

  const handleCancelEditVariant = () => {
    setEditingVariantIndex(null);
    setVariantEditData({
      name: "",
      max_users: "",
      billing_frequency: emptyBillingFrequency()
    });
  };

  const handleUpdateVariant = (variantId) => {
    if (!variantId) {
      toast.error("Variant ID is required for update");

      return;
    }

    if (!hasValidBillingFrequency(variantEditData.billing_frequency)) {
      toast.error("Add at least one billing frequency amount greater than 0");

      return;
    }

    setVariantLoading(true);

    const updateData = {
      billing_frequency: parseBillingFrequency(variantEditData.billing_frequency),
      max_users: parseInt(variantEditData.max_users, 10),
      name: variantEditData.name
    };

    httprequest
      .patch(`${VARIANT}${variantId}`, updateData)
      .then(() => {
        toast.success("Variant updated successfully");
        setEditingVariantIndex(null);
        fetchPricingModels();

        // Also update the local state for the edit modal
        if (editFormData.variants && editFormData.variants[editingVariantIndex]) {
          const updatedVariants = [...editFormData.variants];
          updatedVariants[editingVariantIndex] = {
            ...updatedVariants[editingVariantIndex],
            ...updateData,
            billing_frequency: normalizeBillingFrequency(updateData.billing_frequency)
          };
          setEditFormData({
            ...editFormData,
            variants: updatedVariants
          });
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error updating variant");
      })
      .finally(() => {
        setVariantLoading(false);
      });
  };

  const handleVariantEditInputChange = (e) => {
    const { name, value } = e.target;
    setVariantEditData({
      ...variantEditData,
      [name]: value
    });
  };

  const handleVariantEditBillingChange = (e) => {
    const { name, value } = e.target;
    setVariantEditData({
      ...variantEditData,
      billing_frequency: {
        ...variantEditData.billing_frequency,
        [name]: value
      }
    });
  };

  // Variant Delete Functions
  const handleDeleteVariantModal = (index, variant) => {
    setVariantToDelete({ index, variant });
    setDeleteVariantModal(true);
  };

  const handleDeleteVariant = () => {
    if (!variantToDelete) return;

    const { variant } = variantToDelete;

    if (!variant.id) {
      // If variant doesn't have an ID, it's a new variant that hasn't been saved yet
      // Just remove it from the local state
      handleEditRemoveVariant(variantToDelete.index);
      setDeleteVariantModal(false);
      setVariantToDelete(null);

      return;
    }

    setDeleteVariantLoading(true);

    httprequest
      .delete(`${VARIANT}${variant.id}`)
      .then(() => {
        toast.success("Variant deleted successfully");
        setDeleteVariantModal(false);
        setVariantToDelete(null);
        fetchPricingModels();

        // Also remove from local state
        handleEditRemoveVariant(variantToDelete.index);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error deleting variant");
      })
      .finally(() => {
        setDeleteVariantLoading(false);
      });
  };

  const handleCreateNewVariants = () => {
    if (!currentModelId) {
      toast.error("Plan ID is required to create variants");

      return;
    }

    setVariantLoading(true);

    // Get all new variants (without IDs) that have valid data
    const newVariants = editFormData.variants
      .filter(variant => !variant.id && // Only include variants without IDs (new ones)
        variant.name.trim() !== "" &&
        variant.max_users &&
        hasValidBillingFrequency(variant.billing_frequency)
      )
      .map(variant => ({
        name: variant.name.trim(),
        billing_frequency: parseBillingFrequency(variant.billing_frequency),
        max_users: parseInt(variant.max_users, 10)
      }));

    if (newVariants.length === 0) {
      toast.error("Please add at least one valid new variant with name, max users, and billing amounts");
      setVariantLoading(false);

      return;
    }

    // Make POST request to create new variants
    httprequest
      .post(`${PRICING_ENDPOINT}${currentModelId}/variants`, {
        variants: newVariants
      })
      .then(() => {
        toast.success("New variants created successfully");
        fetchPricingModels();

        // Clear the new variants from the form after successful creation
        const existingVariants = editFormData.variants.filter(v => v.id);
        setEditFormData(prev => ({
          ...prev,
          variants: existingVariants
        }));
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Error creating new variants");
      })
      .finally(() => {
        setVariantLoading(false);
      });
  };

  const featureOptions = Object.entries(availableFeature).map(([label, value]) => ({
    label: label.replace(/_/g, " "),
    value
  }));

  // Separate existing variants and new variants
  const existingVariants = editFormData.variants?.filter(variant => variant.id) || [];
  const newVariants = editFormData.variants?.filter(variant => !variant.id) || [];

  // Check if there are any valid new variants that can be saved
  const hasValidNewVariants = newVariants.some((variant) => variant.name.trim() !== "" && variant.max_users && hasValidBillingFrequency(variant.billing_frequency));

  useEffect(() => {
    fetchPricingModels();
    fetchAvailableFeatures();
  }, []);

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Pricing"
            subtitle="Set the pricing schools and organisation needs to pay."
            button={
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                onClick={handleAddPriceModal}
                buttonName={<div className="flex align-items-center gap-5"><span><AddCircleOutlineIcon /></span>Add New Pricing</div>}
              />
            }
          />
          <div className={`${styles.LayoutContent}`}>
            <Grid container spacing={2} columnSpacing={2}>
              {pricingModels.map((model) => (
                <Grid item lg={4} md={4} sm={6} xs={12} key={model.id}>
                  <PricingComponent
                    title={model.name}
                    titleAmount={formatPlanAmount(model)}
                    content={model.description}
                    features={model.features}
                    hasVariant={model.has_variant}
                    variants={model.variants}
                    icon={
                      <Icon onClick={() => handleDeleteModal(model)}
                        icon="material-symbols:delete-outline" width="24" height="24"
                      />
                    }
                    action={ <Button onClick={() => handleEditPriceModal(model)} buttonName="Edit Price" buttonSize="full" color="btnfontprimary" variant="primaryoutline" />}
                  />
                </Grid>
              ))}
            </Grid>
          </div>

          {/* Add Price Modal */}
          <Modal
            title="Add New Pricing"
            subtitle={
              <div>Here you can set the new pricing for schools to follow.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item xs={12}>
                    <InputGroup
                      label="Plan Name"
                      inputName="name"
                      placeHolder="e.g. Pro Plan"
                      inputType="text"
                      value={formData.name}
                      required
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <InputGroup
                      label="Monthly Amount"
                      inputName="monthly"
                      placeHolder="40000"
                      inputType="number"
                      required
                      value={formData.billing_frequency?.monthly || ""}
                      onChange={handleBillingFrequencyChange}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <InputGroup
                      label="Quarterly Amount"
                      inputName="quarterly"
                      placeHolder="108000"
                      inputType="number"
                      value={formData.billing_frequency?.quarterly || ""}
                      onChange={handleBillingFrequencyChange}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <InputGroup
                      label="Yearly Amount"
                      inputName="yearly"
                      placeHolder="360000"
                      inputType="number"
                      value={formData.billing_frequency?.yearly || ""}
                      onChange={handleBillingFrequencyChange}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p>
                 Select Currency
                        <span className="input-required"> * </span>
                      </p>
                      <Select
                        id="currency"
                        name="currency"
                        options={currencyOptions}
                        value={selectedCurrency}
                        onChange={handleCurrencyChange}
                        placeholder="Select currency..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Max Users"
                      inputName="max_users"
                      placeHolder="e.g. 400"
                      inputType="number"
                      value={formData.max_users}
                      onChange={handleInputChange}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <div className="multiple-select">
                      <p>Select Feature<span className="input-required">*</span></p>
                      <Select
                        isMulti
                        name="allowed_features"
                        options={featureOptions}
                        value={featureOptions.filter(opt => formData.allowed_features.includes(opt.value))}
                        onChange={(selected) => setFormData({
                          ...formData,
                          allowed_features: selected.map(opt => opt.value)
                        })
                        }
                        placeholder="Select features..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <label className="margin-bottom-4">Features</label>
                    {formData?.features?.map((feature, index) => (
                      <div key={index} className={classes.featureitems}>
                        <input
                          className="input_style"
                          type="text"
                          value={feature}
                          onChange={(e) => handleFeatureChange(index, e.target.value)}
                          placeholder={`Feature ${index + 1}`}
                        />
                        {formData.features.length > 1 && (
                          <span onClick={() => handleRemoveFeature(index)} style={{ cursor: "pointer" }}>
                            <Icon icon="mingcute:delete-2-line" color="red" />
                          </span>
                        )}
                      </div>
                    ))}
                    <div onClick={handleAddFeature}
                      className="flex gap-10 add-another-button"
                    ><Icon icon="gg:add" />  Add feature
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.has_variant}
                          onChange={handleVariantToggle}
                          name="has_variant"
                          color="primary"
                        />
                      }
                      label="Enable Plan Variants"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    {formData?.has_variant && (
                      <div className="margin-top-16">
                        <label
                          className={classes.planVariant}
                        >
        Plan Variants
                        </label>

                        {formData.variants.map((variant, index) => (
                          <div
                            key={variant.id || index}
                            className={classes.variants}
                          >
                            <div
                              className={classes.variantHead}
                            >
                              <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "600" }}>
              Variant {index + 1}
                              </h4>
                              {formData.variants.length > 1 && (
                                <Icon
                                  icon="mingcute:delete-2-line"
                                  color="red"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleRemoveVariant(index)}
                                />
                              )}
                            </div>

                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <InputGroup
                                  label="Variant Name"
                                  inputName={`variant_name_${index}`}
                                  placeHolder="e.g. Pro X"
                                  inputType="text"
                                  value={variant.name}
                                  onChange={(e) => handleVariantChange(index, "name", e.target.value)
                                  }
                                  required
                                />
                              </Grid>

                              <Grid item lg={6} md={6} sm={12} xs={12}>
                                <InputGroup
                                  label="Max Users"
                                  inputName={`variant_max_users_${index}`}
                                  placeHolder="e.g. 300"
                                  inputType="number"
                                  value={variant.max_users}
                                  onChange={(e) => handleVariantChange(index, "max_users", e.target.value)
                                  }
                                  required
                                />
                              </Grid>

                              <Grid item lg={4} md={4} sm={12} xs={12}>
                                <InputGroup
                                  label="Monthly"
                                  inputName={`variant_monthly_${index}`}
                                  placeHolder="40000"
                                  inputType="number"
                                  value={variant.billing_frequency?.monthly || ""}
                                  onChange={(e) => handleVariantBillingChange(index, "monthly", e.target.value)}
                                  required
                                />
                              </Grid>
                              <Grid item lg={4} md={4} sm={12} xs={12}>
                                <InputGroup
                                  label="Quarterly"
                                  inputName={`variant_quarterly_${index}`}
                                  placeHolder="108000"
                                  inputType="number"
                                  value={variant.billing_frequency?.quarterly || ""}
                                  onChange={(e) => handleVariantBillingChange(index, "quarterly", e.target.value)}
                                />
                              </Grid>
                              <Grid item lg={4} md={4} sm={12} xs={12}>
                                <InputGroup
                                  label="Yearly"
                                  inputName={`variant_yearly_${index}`}
                                  placeHolder="360000"
                                  inputType="number"
                                  value={variant.billing_frequency?.yearly || ""}
                                  onChange={(e) => handleVariantBillingChange(index, "yearly", e.target.value)}
                                />
                              </Grid>
                            </Grid>
                          </div>
                        ))}

                        <div
                          onClick={handleAddVariant}
                          className={`${classes.top_12_pointer} flex gap-10 add-another-button`}
                        >
                          <Icon icon="gg:add" /> Add Variant
                        </div>
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <TextAreaGroup
                      label="Description"
                      name="description"
                      placeholder="Plan description"
                      value={formData.description}
                      onChange={handleDescriptionChange}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button onClick={handleCreatePricingModel} isLoading={isLoading}
                  variant="primary" buttonSize="full" color="btndefault" buttonName="Add New Pricing"
                />
              </>
            }
            isopen={addpricemodal}
            closeModal={handleAddPriceModal}
          />

          {/* Edit Price Modal */}
          <Modal
            title="Edit Pricing"
            subtitle={
              <div>Here you can update the pricing details.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item xs={12}>
                    <InputGroup
                      label="Plan Name"
                      inputName="name"
                      placeHolder="e.g. Pro Plan"
                      inputType="text"
                      value={editFormData.name}
                      required
                      onChange={handleEditInputChange}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <InputGroup
                      label="Monthly Amount"
                      inputName="monthly"
                      placeHolder="40000"
                      inputType="number"
                      required
                      value={editFormData.billing_frequency?.monthly || ""}
                      onChange={handleEditBillingFrequencyChange}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <InputGroup
                      label="Quarterly Amount"
                      inputName="quarterly"
                      placeHolder="108000"
                      inputType="number"
                      value={editFormData.billing_frequency?.quarterly || ""}
                      onChange={handleEditBillingFrequencyChange}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <InputGroup
                      label="Yearly Amount"
                      inputName="yearly"
                      placeHolder="360000"
                      inputType="number"
                      value={editFormData.billing_frequency?.yearly || ""}
                      onChange={handleEditBillingFrequencyChange}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p>
                        Select Currency
                        <span className="input-required"> * </span>
                      </p>
                      <Select
                        id="currency"
                        name="currency"
                        options={currencyOptions}
                        value={editselectedCurrency}
                        onChange={handleEditCurrencyChange}
                        placeholder="Select currency..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Max Users"
                      inputName="max_users"
                      placeHolder="e.g. 400"
                      inputType="number"
                      value={editFormData.max_users}
                      onChange={handleEditInputChange}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <div className="multiple-select">
                      <p>Available Feature <span className="input-required">*</span></p>
                      <Select
                        isMulti
                        name="allowed_features"
                        options={featureOptions}
                        value={featureOptions.filter(opt => editFormData.allowed_features.includes(opt.value))}
                        onChange={(selected) => setEditFormData({
                          ...editFormData,
                          allowed_features: selected.map(opt => opt.value)
                        })
                        }
                        placeholder="Select features..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <label style={{ marginBottom: "4px" }}>Features</label>
                    {editFormData.features.map((feature, index) => (
                      <div key={index} className={classes.featureitems}>
                        <input
                          className="input_style"
                          type="text"
                          value={feature}
                          onChange={(e) => handleEditFeatureChange(index, e.target.value)}
                          placeholder={`Feature ${index + 1}`}
                        />
                        {editFormData.features.length > 1 && (
                          <span onClick={() => handleEditRemoveFeature(index)} style={{ cursor: "pointer" }}>
                            <Icon icon="mingcute:delete-2-line" color="red" />
                          </span>
                        )}
                      </div>
                    ))}
                    <div onClick={handleEditAddFeature}
                      className="flex gap-10 add-another-button"
                    ><Icon icon="gg:add" />  Add feature
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={editFormData.has_variant}
                          onChange={handleEditVariantToggle}
                          name="has_variant"
                          color="primary"
                        />
                      }
                      label="Enable Plan Variants"
                    />
                  </Grid>

                  {editFormData.has_variant && (
                    <Grid item xs={12}>
                      {editFormData.has_variant && (
                        <div className="margin-top-16">
                          <label
                            className={classes.planVariant}
                          >
                            Plan Variants
                          </label>

                          {/* Existing Variants Section */}
                          {existingVariants.length > 0 && (
                            <div style={{ marginBottom: "24px" }}>
                              <h4 className={classes.existingVariant}>
                                Existing Variants
                              </h4>
                              {existingVariants.map((variant) => {
                                const actualIndex = editFormData.variants.findIndex(v => v.id === variant.id);

                                return (
                                  <div
                                    key={variant.id}
                                    className={classes.variantId}
                                  >
                                    <div className={classes.underVariantId}>
                                      <h4 className={classes.variantName}>
                                        {variant.name}
                                      </h4>
                                      <div className={classes.variantdEdits}>
                                        {editingVariantIndex === actualIndex ? (
                                          <>
                                            <Button
                                              onClick={() => handleUpdateVariant(variant.id)}
                                              isLoading={variantLoading}
                                              variant="primary"
                                              buttonSize="small"
                                              color="btndefault"
                                              buttonName="Save"
                                            />
                                            <Icon
                                              icon="material-symbols:cancel"
                                              color="gray"
                                              className="cursor-pointer"
                                              onClick={handleCancelEditVariant}
                                            />
                                          </>
                                        ) : (
                                          <Icon
                                            icon="material-symbols:edit"
                                            color="blue"
                                            className="cursor-pointer"
                                            onClick={() => handleEditVariant(actualIndex, variant)}
                                          />
                                        )}
                                        <Icon
                                          icon="mingcute:delete-2-line"
                                          color="red"
                                          className="cursor-pointer"
                                          onClick={() => handleDeleteVariantModal(actualIndex, variant)}
                                        />
                                      </div>
                                    </div>

                                    <Grid container spacing={2}>
                                      <Grid item xs={12}>
                                        <InputGroup
                                          label="Variant Name"
                                          inputName="name"
                                          placeHolder="e.g. Pro X"
                                          inputType="text"
                                          value={editingVariantIndex === actualIndex ? variantEditData.name : variant.name}
                                          onChange={editingVariantIndex === actualIndex ?
                                            handleVariantEditInputChange :
                                            () => {} // No change handler when not editing
                                          }
                                          disabled={editingVariantIndex !== actualIndex} // Disable unless editing this specific variant
                                          required
                                        />
                                      </Grid>

                                      <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <InputGroup
                                          label="Max Users"
                                          inputName="max_users"
                                          placeHolder="e.g. 300"
                                          inputType="number"
                                          value={editingVariantIndex === actualIndex ? variantEditData.max_users : variant.max_users}
                                          onChange={editingVariantIndex === actualIndex ?
                                            handleVariantEditInputChange :
                                            () => {} // No change handler when not editing
                                          }
                                          disabled={editingVariantIndex !== actualIndex} // Disable unless editing this specific variant
                                          required
                                        />
                                      </Grid>

                                      <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <InputGroup
                                          label="Monthly"
                                          inputName="monthly"
                                          placeHolder="40000"
                                          inputType="number"
                                          value={editingVariantIndex === actualIndex
                                            ? variantEditData.billing_frequency?.monthly || ""
                                            : variant.billing_frequency?.monthly || variant.price || ""}
                                          onChange={editingVariantIndex === actualIndex
                                            ? handleVariantEditBillingChange
                                            : () => {}}
                                          disabled={editingVariantIndex !== actualIndex}
                                          required
                                        />
                                      </Grid>
                                      <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <InputGroup
                                          label="Quarterly"
                                          inputName="quarterly"
                                          placeHolder="108000"
                                          inputType="number"
                                          value={editingVariantIndex === actualIndex
                                            ? variantEditData.billing_frequency?.quarterly || ""
                                            : variant.billing_frequency?.quarterly || ""}
                                          onChange={editingVariantIndex === actualIndex
                                            ? handleVariantEditBillingChange
                                            : () => {}}
                                          disabled={editingVariantIndex !== actualIndex}
                                        />
                                      </Grid>
                                      <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <InputGroup
                                          label="Yearly"
                                          inputName="yearly"
                                          placeHolder="360000"
                                          inputType="number"
                                          value={editingVariantIndex === actualIndex
                                            ? variantEditData.billing_frequency?.yearly || ""
                                            : variant.billing_frequency?.yearly || ""}
                                          onChange={editingVariantIndex === actualIndex
                                            ? handleVariantEditBillingChange
                                            : () => {}}
                                          disabled={editingVariantIndex !== actualIndex}
                                        />
                                      </Grid>
                                    </Grid>
                                  </div>
                                );
                              })}
                            </div>
                          )}

                          {/* New Variants Section */}
                          <div className={classes.variantSection}>
                            <h4 className={classes.newVariant}>
                              <Icon icon="mdi:plus-circle" width="20" height="20" />
                              New Variants
                            </h4>
                            <p className={classes.addvariantInfo}>
                              Add new variants below. They will be created when you click "Create New Variants".
                            </p>

                            {newVariants.map((variant, index) => {
                              const actualIndex = editFormData.variants.findIndex(v => !v.id && v === variant);

                              return (
                                <div
                                  key={index}
                                  className={classes.variantDetailInfo}
                                >
                                  <div className={classes.variantandIcon}>
                                    <h4 className={classes.variantHeadline}>
                                      New Variant {index + 1}
                                    </h4>
                                    <Icon
                                      icon="mingcute:delete-2-line"
                                      color="#ff4d4f"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleDeleteVariantModal(actualIndex, variant)}
                                    />
                                  </div>

                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <InputGroup
                                        label="Variant Name"
                                        inputName={`new_variant_name_${index}`}
                                        placeHolder="e.g. Pro X"
                                        inputType="text"
                                        value={variant.name}
                                        onChange={(e) => handleNewVariantChange(actualIndex, "name", e.target.value)}
                                        required
                                      />
                                    </Grid>

                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                      <InputGroup
                                        label="Max Users"
                                        inputName={`new_variant_max_users_${index}`}
                                        placeHolder="e.g. 300"
                                        inputType="number"
                                        value={variant.max_users}
                                        onChange={(e) => handleNewVariantChange(actualIndex, "max_users", e.target.value)}
                                        required
                                      />
                                    </Grid>

                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                      <InputGroup
                                        label="Monthly"
                                        inputName={`new_variant_monthly_${index}`}
                                        placeHolder="40000"
                                        inputType="number"
                                        value={variant.billing_frequency?.monthly || ""}
                                        onChange={(e) => handleNewVariantBillingChange(actualIndex, "monthly", e.target.value)}
                                        required
                                      />
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                      <InputGroup
                                        label="Quarterly"
                                        inputName={`new_variant_quarterly_${index}`}
                                        placeHolder="108000"
                                        inputType="number"
                                        value={variant.billing_frequency?.quarterly || ""}
                                        onChange={(e) => handleNewVariantBillingChange(actualIndex, "quarterly", e.target.value)}
                                      />
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                      <InputGroup
                                        label="Yearly"
                                        inputName={`new_variant_yearly_${index}`}
                                        placeHolder="360000"
                                        inputType="number"
                                        value={variant.billing_frequency?.yearly || ""}
                                        onChange={(e) => handleNewVariantBillingChange(actualIndex, "yearly", e.target.value)}
                                      />
                                    </Grid>
                                  </Grid>
                                </div>
                              );
                            })}

                            <div
                              onClick={handleEditAddVariant}
                              className={`${classes.newVariantBottom} "flex gap-10 add-another-button"`}
                            >
                              <Icon icon="gg:add" /> Add Another New Variant
                            </div>
                          </div>

                          {/* Create New Variants Button */}
                          {newVariants.length > 0 && (
                            <div className={classes.variantOne}>
                              <h4 className={classes.readyVariant}>
                                Ready to Create New Variants
                              </h4>
                              <p className={classes.validVariant}>
                                {hasValidNewVariants
                                  ? "All new variants are filled correctly. Click below to save them to the database."
                                  : "Please fill in all required fields (name, max users, and at least one billing amount) for the new variants."
                                }
                              </p>
                              <Button
                                onClick={handleCreateNewVariants}
                                isLoading={variantLoading}
                                variant="primary"
                                buttonSize="full"
                                color="btndefault"
                                buttonName="Create New Variants"
                                disabled={!hasValidNewVariants}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <TextAreaGroup
                      label="Description"
                      name="description"
                      placeholder="Plan description"
                      value={editFormData.description}
                      onChange={handleEditDescriptionChange}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button
                  onClick={handleUpdatePricingModel}
                  isLoading={isLoading}
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Update Pricing"
                />
              </>
            }
            isopen={editpricemodal}
            closeModal={handleCloseEditModal}
          />

          {/* Delete Pricing Model Modal */}
          <Modal
            title="Delete Pricing Model"
            subtitle="Are you sure you want to delete this pricing model? This action cannot be undone."
            modalContent={
              <div className="text-center">
                <p>This will permanently remove the pricing model and all associated data.</p>
              </div>
            }
            modalFooter={
              <Button
                onClick={handleDeletePricingModel}
                isLoading={deleteLoading}
                variant="danger"
                buttonSize="full"
                color="btndefault"
                buttonName="Delete"
              />
            }
            isopen={deleteModal}
            closeModal={handleDeleteModal}
          />

          {/* Delete Variant Modal */}
          <Modal
            title="Delete Variant"
            subtitle="Are you sure you want to delete this variant? This action cannot be undone."
            modalContent={
              <div className="">
                <p>This will permanently remove the variant from the pricing plan.</p>
                {variantToDelete && (
                  <div className={classes.deleteVariantHeader}>
                    <p><strong>Variant Name:</strong> {variantToDelete?.variant?.name}</p>
                    <p><strong>Max Users:</strong> {variantToDelete?.variant?.max_users}</p>
                    <p>
                      <strong>Price:</strong>
                      {" "}
                      {Number(
                        variantToDelete?.variant?.billing_frequency?.monthly ??
                        variantToDelete?.variant?.price ??
                        0
                      ).toLocaleString()}
                      /mo
                    </p>
                    {!variantToDelete.variant.id && (
                      <p className={classes.strongDetail}>
                        <strong>Note:</strong> This variant has not been saved yet and will be removed immediately.
                      </p>
                    )}
                  </div>
                )}
              </div>
            }
            modalFooter={
              <Button
                onClick={handleDeleteVariant}
                isLoading={deleteVariantLoading}
                variant="danger"
                buttonSize="full"
                color="btndefault"
                buttonName="Delete Variant"
              />
            }
            isopen={deleteVariantModal}
            closeModal={() => {
              setDeleteVariantModal(false);
              setVariantToDelete(null);
            }}
          />

          <ToastContainer />
        </>
      }
    />
  );
};

export default Pricing;
